/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaStep/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaCheck from 'DesignSystem/Svgs/TysiaCheck/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaStep({
  children,
  viewPath = "/DesignSystem/TysiaStep",
  selected,
  complete,
  step,
  weight,
  size,
  text
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let dtColorsGreen700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.700'
        })
let dtColorsNeutral800 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.800'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
  return (<React.Fragment
>
<div
  data-testid="TysiaStep.Horizontal"
  data-view-path={viewPath}
 style={{'--o-1-1bFhnF': selected ? 1 : 0.6}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="TysiaStep.Vertical"
  data-view-path={viewPath}
 style={{'--mr-2-1bFhnF': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bc-4-1bFhnF': selected ? dtColorsGreen700 : "white",'--bc-3-1bFhnF': selected ? dtColorsGreen700 : complete ? dtColorsGreen700 : dtColorsNeutral500}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={selected ? dtColorsWhite : dtColorsNeutral800}
 display={complete ? "none" : "flex"}
 text={step}
/>
<div
  data-testid="TysiaStep.Horizontal:1"
  data-view-path={viewPath}
 style={{'--d-5-1bFhnF': complete ? "flex" : "none"}}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaCheck
  viewPath={`${viewPath}/TysiaCheck`}
 fill={dtColorsWhite}
 fill2={dtColorsWhite}
 width={14}
/>
</div>
</div>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight={weight}
 size={size}
 text={text}
/>
</div>
{children}
</React.Fragment>)
}